exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".thumbnail[data-v-6827ab52]{position:relative;user-select:none;cursor:pointer}.thumbnail:hover img[data-v-6827ab52]{opacity:.95}img[data-v-6827ab52]{pointer-events:none}p[data-v-6827ab52]{margin-bottom:0}.row-table[data-v-6827ab52]{margin:0}.col-table[data-v-6827ab52]{vertical-align:bottom;padding:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6827ab52","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/CarItemC.vue
// module id = 42
// module chunks = 0